<!--
  Иконка ключа
  Используется для полей и блоков с ключом источника данных
-->
<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
  >
    <circle cx="8" cy="12" r="4" :stroke="stroke" stroke-width="2" />
    <path
      d="M12 12H21M17 12V15M20 12V15"
      :stroke="stroke"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle cx="8" cy="12" r="1" :fill="stroke" />
  </svg>
</template>

<script>
export default {
  name: "KeyIcon",

  props: {
    size: {
      type: [Number, String],
      default: 20,
    },
    stroke: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>
